import DesktopPlug from './DesktopPlug';

export default DesktopPlug;